import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function useGoBack(fallbackRoute?: string) {
	const location = useLocation();
	const navigate = useNavigate();

	const canGoBack = location.key && location.key !== 'default';

	const goBack = useCallback(() => {
		if (canGoBack) {
			navigate(-1);
		} else if (fallbackRoute) {
			navigate(fallbackRoute, { replace: true });
		}
	}, [canGoBack, fallbackRoute, navigate]);

	return { canGoBack, goBack };
}
